import * as L from "leaflet";
import turf from "turf";
import {bounds} from "leaflet/dist/leaflet-src.esm";
var Cesium = require("cesium/Cesium");

export default {
    getCameraLevel(height) {
        if (height > 48000000) {
            return 0;
        } else if (height > 24000000) {
            return 1;
        } else if (height > 12000000) {
            return 2; // 曾使用
        } else if (height > 6000000) {
            return 3;
        } else if (height > 3000000) {
            return 4;
        } else if (height > 1500000) {
            return 5;
        } else if (height > 750000) {
            return 6;
        } else if (height > 375000) {
            return 7;
        } else if (height > 187500) {
            return 8;
        } else if (height > 93750) {
            return 9;
        } else if (height > 46875) {
            return 10;
        } else if (height > 23438) {
            return 11;
        } else if (height > 11719) {
            return 12;
        } else if (height > 5860) {
            return 13;
        } else if (height > 2930) {
            return 14;
        } else if (height > 1465) {
            return 15;
        } else if (height > 733) {
            return 16;
        } else if (height > 367) {
            return 17;
        } else {
            return 18;
        }
    },
    changeZoomHeight(zoomLevel){
        switch (zoomLevel) {
            case 1:
                this.flyToHeight(48000000)
                break;
            case 2:
                this.flyToHeight(24000000)
                break;
            case 3:
                this.flyToHeight(12000000)
                break;
            case 4:
                this.flyToHeight(6000000)
                break;
            case 5:
                this.flyToHeight(3000000)
                break;
            case 6:
                this.flyToHeight(1500000)
                break;
            case 7:
                this.flyToHeight(750000)
                break;
            case 8:
                this.flyToHeight(375000)
                break;
            case 9:
                this.flyToHeight(187500)
                break;
            case 10:
                this.flyToHeight(93750)
                break;
            case 11:
                this.flyToHeight(46875)
                break;
            case 12:
                this.flyToHeight(23438)
                break;
            case 13:
                this.flyToHeight(11719)
                break;
            case 14:
                this.flyToHeight(5860)
                break;
            case 15:
                this.flyToHeight(2930)
                break;
            case 16:
                this.flyToHeight(1465)
                break;
            case 17:
                this.flyToHeight(733)
                break;
            case 18:
                this.flyToHeight(367)
                break;
        }
    },
    quitCompare(compare){
        compare.compareShowMode = "";
        for (const key of ['topLeft', 'topRight', 'bottomLeft', 'bottomRight']) {
            if (Object.keys(compare.mapContent.maps[key]).length!==0) {
                compare.mapContent.maps[key].remove();
            }
        }
        if (Object.keys(compare.mapContent.layerGroup).length !== 0){
            compare.mapContent.layerGroup.clearLayers();
        }
        if (compare.mapContent.baseMap) {
            compare.mapContent.baseMap.remove();
        }
        compare.mapContent = {
            maps: { "topLeft": {}, "topRight": {}, "bottomLeft": {}, "bottomRight": {} },
            layerGroup: {},
            baseMap: undefined,
        };
        if (compare.screenList.length === 4) {
            compare.screenList.splice(-2, 2);
        }
        compare.screenList.forEach(item => {
            item.isLeafletOff = true;
            item.curDataTitle = "";
        })
        compare.zIndex = -1;
        compare.rollerList.forEach(item => {
            item.isLeafletOff = true;
            item.curDataTitle = "";
        })
    },
    initMap(id, geojson, state){
        let mapContent = state.compare.mapContent;
        let servicePath = state.servicePath;
        // 初始化地图
        let map = L.map(id, {
            center: [43.88,125.35],
            zoom: 3,
            zoomSnap: 0,
            zoomControl: false,
            doubleClickZoom : false,
            maxZoom: 18,
        })
        // 设置Google, 天地图坐标图层，使用vuex保存图层
        L.tileLayer(servicePath.tdtImgUrl, {
            subdomains: ['khm0','khm1','khm2','khm3']
        }).addTo(map);
        L.tileLayer(servicePath.tdtImgBzUrl, {
            subdomains:['0', '1', '2', '3'],
            zIndex:999
        }).addTo(map);
        mapContent.layerGroup = L.layerGroup().addTo(map);
        this.roadButtonShow = true;
        this.calcCoordinates(map, geojson);
        map.attributionControl.setPrefix("");
        // 添加mousemove事件，更新右下角经纬度及zoom
        map.on("mousemove", event => {
            document.getElementById("longitudeStr").innerText = event.latlng.lng.toFixed(2);
            document.getElementById("latitudeStr").innerText = event.latlng.lat.toFixed(2);
        })
        return map;
    },
    calcCoordinates(map, geojson){
        // 返回西南，东北
        let bound = L.geoJSON(geojson).getBounds();
        let southWest = [ bound._southWest.lat, bound._southWest.lng];
        let northEast = [ bound._northEast.lat, bound._northEast.lng];
        map.fitBounds([southWest, northEast]);
    },
    addLayer(layerName, geo, state){
        // leaflet的添加图层
        let layerGroup = state.compare.mapContent.layerGroup
        layerName=layerName.replace('http://121.36.71.163:3000',
            '/hwtile');
        let layer = L.tileLayer(layerName, { tms: true }).addTo(layerGroup);
        return layer
    },
    addCesiumLayer(layerUrl, geo){
        let imageryLayers = window.viewer.imageryLayers;
        let newUrl = layerUrl.replace('y', 'reverseY');
        newUrl=newUrl.replace('http://121.36.71.163:3000',
            '/hwtile');
        let region = turf.envelope(geo).geometry.coordinates[0];
        let rectangle = Cesium.Rectangle.fromDegrees( region[0][0], region[0][1], region[2][0], region[2][1]);
        let curProvider = new Cesium.UrlTemplateImageryProvider({
            url : newUrl,
            tilingScheme : new Cesium.WebMercatorTilingScheme(),
            rectangle: rectangle, // 设置位置
        });

        let layer = imageryLayers.addImageryProvider(curProvider);
        layer.minificationFilter = Cesium.TextureMinificationFilter.NEAREST;
        layer.magnificationFilter = Cesium.TextureMagnificationFilter.NEAREST;
        imageryLayers.raiseToTop(layer);
        return layer;
    },
    getKey(){
        if (document.cookie.length > 0){
            let start = document.cookie.indexOf('key' + "=");
            if(start != -1){
                start = start + 'key'.length + 1;
                let end = document.cookie.indexOf(";",start);
                if (end == -1){
                    end = document.cookie.length;
                }
                return unescape(document.cookie.substring(start,end));
            }
        }
    },
    saveUserInfo(res, state, route){
        // 保存用户信息
        state.user.userId = res.data.data.account;
        localStorage.setItem("userId", res.data.data.account);
        state.user.userName = res.data.data.name;
        localStorage.setItem("userName", res.data.data.name);
        state.user.role = res.data.data.roleId;
        localStorage.setItem("role", res.data.data.roleId);
        state.user.dept = res.data.data.deptId;
        localStorage.setItem("dept", res.data.data.deptId);
        state.user.token = res.data.data.token;
        localStorage.setItem("token", res.data.data.token);
        state.user.loginToken = res.data.data.loginToken;
        localStorage.setItem("loginToken", res.data.data.loginToken);
        // 设置页面状态
        state.user.logined = true;
        if(res.data.data.noticeFlag==1)
        {
           state.user.dialogTip = true
        }
        if (route.history.current.path !== '/home') {
            route.push("/home");
        }
        // Home页初始化
        state.compare.compareShowMode = "";
        state.showDeliveryDetail = false;
        state.showDetail = false;
        state.isGallery = 1;
        state.myLabFucChecked = 0;
        state.noneDelivery = false;
        state.sortByField = "time";
        state.sortDire = "desc";
    },
    calcHeight(clientY){
        let detailHeight = 575;            // 详情框高度
        let globeHeight = document.body.clientHeight - 48;  // 球区域可移动的高度
        let mouseYToGlobe = clientY - 48;  // 鼠标相对于球区域上边沿的高度
        if(mouseYToGlobe < detailHeight/2){  // 靠上侧
            return  0 + "px";
        } else if (globeHeight - mouseYToGlobe < detailHeight/2){  // 靠下侧
            return  globeHeight - detailHeight - 10 + "px";
        } else {  // 居中
            return  mouseYToGlobe - detailHeight/2 + "px";
        }
    },
    deepArrange(node, path, id){
        if (node.hasOwnProperty("folderId")) {
            // 处理文件夹
            node["selectedNum"] = 0;
            node["layerNum"] = node.layerNum;
            node["type"] = "folder";
            node["id"] = node.folderId;
            delete node.folderId;
            node["name"] = node.folderName;
            delete node.folderName;
            if (node.hasOwnProperty("folderInfoDtos")){
                node["children"] = node.folderInfoDtos.slice(0);
                delete node.folderInfoDtos;
            }
            if (node.hasOwnProperty("productInfos")){
                if (node.hasOwnProperty("children")){
                    node["children"] = node.children.concat(node.productInfos);
                } else {
                    node["children"] = node.productInfos.slice(0);
                }
                delete node.productInfos;
            }
            if (!node.hasOwnProperty("children")){
                node["children"] = [];
            }
            if (node.children.length>0) {
                for (let i = 0; i < node.children.length; i++) {
                    this.deepArrange(node.children[i])
                }
            }
        } else {
            // 处理产品数据
            node["type"] = "product";
            node["id"] = node.productCode;
            delete node.productCode;
            node["name"] = node.productName;
            delete node.productName;
            if (node.dataGeojson) {
                node["geojson"] = node.dataGeojson;
                delete node.dataGeojson;
            }
        }
        if(id){
            for(let child of node['children']){
                child['parentPath'] = path.concat([id])
            }
        }

    },
}